import { useEffect, useRef, useState } from 'react';

/**
 * Custom hook for fade-in-up animation on scroll
 * @param {number} threshold - Intersection observer threshold (0-1)
 * @param {string} delay - Animation delay (e.g., '0ms', '100ms', '200ms')
 * @returns {object} - { ref, isVisible }
 */
export const useFadeInUp = (threshold = 0.1, delay = '0ms') => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          // Once visible, stop observing
          observer.unobserve(entry.target);
        }
      },
      { 
        threshold,
        rootMargin: '50px' // Element görünmeden 50px önce trigger et
      }
    );

    const currentRef = ref.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [threshold]);

  return {
    ref,
    className: `transition-all duration-700 ease-out ${
      isVisible 
        ? 'opacity-100 translate-y-0' 
        : 'opacity-0 translate-y-8'
    }`,
    style: { 
      transitionDelay: delay,
      opacity: isVisible ? 1 : 0,
      transform: isVisible ? 'translateY(0)' : 'translateY(8px)'
    }
  };
};

